// extracted by mini-css-extract-plugin
module.exports = {"month":"month-3_c1h","week":"week-1KuC9"};